import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_MANAGE: MijnRoute = {
    path: ':id/beheer',
    navigationEvent: 'toBeleggenBeheer',
    regex: /^\/beleggen\/[^/]+\/beheer$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/beheer'
};
